export const JWT_CONFIG = {
  refreshToken: 'refreshToken',
  jwtCookieName: 'jwt',
  IdTokenHint:'IdTokenHint'
}
